module.exports = __webpack_public_path__ + "img/the-excellence-partnership.e2e1477b.png";